import React, { Component } from "react";
import { withRouter } from "react-router";
import ChatSupportBtn from "./ChatSupportBtn";
import { logout, generateId } from "./Utility";
import customFetch from "./apicall/api";

class KYCDocuments extends Component {
  constructor(props) {
    super(props);
    this.watermarkCanvasRef = React.createRef();
    this.state = {
      householdNumber: "",
      household_id: null,
      familyMembers: [],
      selectedFamilyMember: null,
      kycDocuments: [],
      loading: false,
      error: null,
      showFamilyMembers: false,
      showDocuments: false,
      api_token: "",
      effective_designation_id: "",
      selectedDocumentForWatermark: null,
      selectedWatermarkDocument: null,
      watermarkEditorConfig: null,
      watermarkImageUrl: null,
      watermarkObjectUrl: null,
      watermarkCanvasWidth: 0,
      watermarkCanvasHeight: 0,
      watermarkOriginalImage: null,
      isDraggingWatermark: false,
      dragStart: { x: 0, y: 0 },
      dragOffset: { x: 0, y: 0 },
      watermarkError: null,
      watermarkSaving: false,
      showDocumentModal: false,
      documentPreviewUrl: null,
      documentPreviewName: "",
      watermarkEditableText: "",
      watermarkBold: false,
      watermarkLatitude: null,
      watermarkLongitude: null,
      watermarkTextAutoGenerated: true,
      useDocumentGPS: false,
      watermarkTextEmpty: false,
      watermarkTextValidationError: "",
      userId: localStorage.getItem("in_userid"),
    };
  }

  componentDidMount() {
    document.title = "KYC Documents";
    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      localStorage.clear();
      this.props.history.push("/");
    }
    const { effective_designation_id, api_token } =
      (this.props.location && this.props.location.state) || {};
    this.setState({
      effective_designation_id: effective_designation_id,
      api_token: api_token,
    });
  }

  fetchKYCDocuments = async () => {
    const { householdNumber, api_token } = this.state;

    if (!householdNumber.trim()) {
      this.setState({ error: "Please enter a household number" });
      return;
    }

    this.setState({ loading: true, error: null, showFamilyMembers: false });

    try {
      const queryParams = new URLSearchParams({
        household_number: householdNumber,
      }).toString();

      const response = await customFetch(
        process.env.REACT_APP_URL + "/get/household/familyMembers?" + queryParams,
        {
          method: "GET",
          headers: { "api-token": api_token },
        }
      );

      if (response.headers.get("api_code") > 0) {
        throw new Error(response.headers.get("api_error_message") || "Failed to fetch family members");
      }

      const data = await response.json();

      if (data.status === 1 && data.data && data.data.length > 0) {
        // Extract household_id from the response (usually in first member or at response level)
        const household_id = data.household_id || (data.data[0] && data.data[0].household_id);
        this.setState({
          familyMembers: data.data,
          household_id: household_id,
          showFamilyMembers: true,
          loading: false,
          showDocuments: false,
          selectedFamilyMember: null,
        });
      } else {
        this.setState({
          error: "No family members found for this household number",
          loading: false,
          showFamilyMembers: false,
        });
      }
    } catch (error) {
      this.setState({
        error: error.message || "Error fetching family members",
        loading: false,
        showFamilyMembers: false,
      });
    }
  };

  groupDocumentsByType = (documents) => {
    const grouped = {};

    documents.forEach((doc) => {
      // Determine if it's a watermark document
      const isWatermark = doc.upload_document_type_name.toLowerCase().includes('watermark');

      // Get base document type (remove "Watermark" from name)
      const baseType = doc.upload_document_type_name.replace(/\s*Watermark\s*$/i, '').trim();

      if (!grouped[baseType]) {
        grouped[baseType] = {
          original: null,
          watermark: null,
        };
      }

      if (isWatermark) {
        grouped[baseType].watermark = doc;
      } else {
        grouped[baseType].original = doc;
      }
    });

    // Convert to array format for easier rendering
    return Object.entries(grouped).map(([type, docs]) => ({
      documentType: type,
      original: docs.original,
      watermark: docs.watermark,
    }));
  };

  fetchDocumentsForMember = async (familyMember) => {
    const { api_token, household_id } = this.state;

    this.setState({ loading: true, error: null, selectedFamilyMember: familyMember });

    try {
      const queryParams = new URLSearchParams({
        household_id: household_id,
        family_member_id: familyMember.family_member_id,
      }).toString();

      const response = await customFetch(
        process.env.REACT_APP_URL + "/get/household/documents?" + queryParams,
        {
          method: "GET",
          headers: { "api-token": api_token },
        }
      );

      if (response.headers.get("api_code") > 0) {
        throw new Error(response.headers.get("api_error_message") || "Failed to fetch documents");
      }

      const data = await response.json();

      if (data.data && data.data.length > 0) {
        // Group documents by type (original vs watermark)
        const groupedDocuments = this.groupDocumentsByType(data.data);

        this.setState({
          kycDocuments: groupedDocuments,
          loading: false,
          showDocuments: true,
          showFamilyMembers: true,
        });
      } else {
        this.setState({
          kycDocuments: [],
          error: "No documents found for this family member",
          loading: false,
          showDocuments: true,
          showFamilyMembers: true,
        });
      }
    } catch (error) {
      this.setState({
        kycDocuments: [],
        error: error.message || "Error fetching documents",
        loading: false,
        showDocuments: true,
        showFamilyMembers: true,
      });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.fetchKYCDocuments();
    }
  };

  createRandomId = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  getAddressFromLatLng = async (lat, lng) => {
    try {
      // Use OpenStreetMap Nominatim reverse geocoding API (free, no key required)
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
        {
          headers: {
            'Accept-Language': 'en',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch location');
      }

      const data = await response.json();
      
      // Build location string from address components
      if (data.address) {
        // Prefer city/town/village, fallback to state/country
        const city = data.address.city || 
                     data.address.town || 
                     data.address.village || 
                     data.address.county || 
                     '';
        const state = data.address.state || '';
        const country = data.address.country || '';
        
        // Construct address string: "City, State, Country"
        const parts = [city, state, country].filter(Boolean);
        const address = parts.join(', ') || `${lat}, ${lng}`;
        
        return address;
      }

      // Fallback to display_name if address parsing fails
      return data.display_name || `${lat}, ${lng}`;
    } catch (error) {
      console.warn('Reverse geocoding failed:', error);
      // Fallback to coordinates string if API call fails
      return `${lat}, ${lng}`;
    }
  };

  extractDocumentType = (filename, memberLetter) => {
    if (!filename) return "";
    const parts = filename.split('/');
    const lastPart = parts[parts.length - 1];
    const nameWithoutExt = lastPart.split('.')[0];
    // Remove all leading segments: optional random 3-digit prefix, then one or more household-member patterns
    // Pattern: {random}_{household-letter}_{household-letter}_..._DocumentType
    // Regex matches: optional(digits_) + one or more(alphanum-Letter_)
    const withoutPrefixes = nameWithoutExt.replace(/^(?:\d{3}_)?(?:[A-Za-z0-9_]+-[A-Z]_)+/, '');
    // Remove all watermark-related suffixes (Watermark, Watermarked, etc.)
    const withoutWatermark = withoutPrefixes.replace(/Watermark(ed)?$/i, '');
    return withoutWatermark;
  };

  generateSaveFilename = (householdNumber, memberLetter, documentType, rawFilename) => {
    const randomDigits = Math.floor(Math.random() * 900 + 100).toString();
    // Get extension from rawFilename
    const lastDotIndex = rawFilename.lastIndexOf('.');
    const extension = lastDotIndex !== -1 ? rawFilename.substring(lastDotIndex) : '.jpeg';
    const filename = `${randomDigits}_${householdNumber}-${memberLetter}_${documentType}Watermark${extension}`;
    return filename;
  };

  randomizePathDigits = (rawFilename) => {
    const kycIndex = rawFilename.indexOf("KYC/");
    let compressedFilename = kycIndex >= 0 ? rawFilename.substring(kycIndex) : rawFilename;

    // Replace "Watermarked" with "Watermark" if present
    compressedFilename = compressedFilename.replace(/Watermarked/gi, 'Watermark');

    const digitsPattern = /\/KYC\/\d{4}\/\d{1,2}\/(\d{3})_/;
    const digitsMatch = compressedFilename.match(digitsPattern);
    if (digitsMatch) {
      const currentDigits = digitsMatch[1];
      let newDigits;
      do {
        newDigits = Math.floor(Math.random() * 900 + 100).toString();
      } while (newDigits === currentDigits);
      compressedFilename = compressedFilename.replace(digitsPattern, (match) => {
        return match.replace(currentDigits, newDigits);
      });
    }

    if (!/Watermark/i.test(compressedFilename)) {
      compressedFilename = compressedFilename.replace(/(\.[^.]+)$/, (ext) => `Watermark${ext}`);
    }

    return compressedFilename;
  };

  normalizeSourceBlobPath = (path) => {
    if (!path) return "";
    const cleaned = path.trim();
    const match = cleaned.match(/^(.+?\.(?:jpeg|jpg|png|pdf|docx?|xlsx?|txt))(?:\/.*)?$/i);
    return match ? match[1] : cleaned;
  };

  getDocumentSourceName = (document) => {
    return (
      document.source_blob_name ||
      document.document_url ||
      document.uploaded_url ||
      document.file_url ||
      document.filename ||
      ""
    );
  };

  getDocumentDownloadUrl = (document) => {
    return (
      document.document_url ||
      document.uploaded_url ||
      document.file_url ||
      document.filename ||
      document.source_blob_name ||
      ""
    );
  };

  downloadFile = (document) => {
    const url = this.getDocumentDownloadUrl(document);
    if (!url) return;

    const filename = url.split('/').pop() || 'document';
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  fetchDocumentBlobUrl = async (document) => {
    const { api_token } = this.state;
    const sourceName = this.getDocumentSourceName(document);
    if (!sourceName) {
      throw new Error('Document source is not available for preview.');
    }

    const fileDownloadUrl = process.env.REACT_APP_FILE_DOWNLOAD;
    if (!fileDownloadUrl) {
      throw new Error('File download service is not configured.');
    }

    const apiUrl = `${fileDownloadUrl}/gcs/download`;
    const requestOptions = {
      method: 'POST',
      headers: {
        'api-token': api_token,
        component_id: this.createRandomId(10),
        apiId: this.createRandomId(10),
        api_group_id: '',
        component: 'KYCDocuments',
        user_id: localStorage.getItem('in_userid'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ source_blob_name: sourceName }),
    };

    const response = await customFetch(apiUrl, requestOptions);
    if (!response.ok || (response.headers && response.headers.get('api_code') > 0)) {
      const apiError = response.headers ? response.headers.get('api_error_message') : null;
      throw new Error(apiError || `Failed to fetch document preview (${response.status})`);
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  };

  downloadFile = (document) => {
    const url = this.getDocumentSourceName(document);
    if (!url) return;

    const filename = url.split('/').pop() || 'document';
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  openPreviewModal = async (document) => {
    try {
      const previewUrl = await this.fetchDocumentBlobUrl(document);
      if (this.state.documentPreviewUrl && this.state.documentPreviewUrl !== previewUrl) {
        URL.revokeObjectURL(this.state.documentPreviewUrl);
      }

      this.setState({
        documentPreviewUrl: previewUrl,
        documentPreviewName: this.getDocumentSourceName(document).split('/').pop() || 'document',
        showDocumentModal: true,
        loading: false,
        error: null,
      });
    } catch (error) {
      this.setState({ error: error.message || 'Unable to preview document', loading: false });
    }
  };

  closeDocumentModal = () => {
    if (this.state.documentPreviewUrl) {
      URL.revokeObjectURL(this.state.documentPreviewUrl);
    }
    this.setState({ showDocumentModal: false, documentPreviewUrl: null, documentPreviewName: "" });
  };

  getCurrentLocation = () => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude.toFixed(4);
        const longitude = position.coords.longitude.toFixed(4);

        this.setState((prevState) => {
          const config = prevState.watermarkEditorConfig ? { ...prevState.watermarkEditorConfig } : null;
          const shouldUpdateText = prevState.watermarkTextAutoGenerated;
          if (config && shouldUpdateText) {
            config.text = this.getWatermarkText(latitude, longitude);
          }

          return {
            watermarkLatitude: latitude,
            watermarkLongitude: longitude,
            watermarkEditorConfig: config,
            watermarkEditableText: shouldUpdateText ? (config ? config.text : prevState.watermarkEditableText) : prevState.watermarkEditableText,
          };
        }, this.drawWatermarkPreview);
      },
      (error) => {
        console.warn("Geolocation failed:", error);
      },
      { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
    );
  };

  getWatermarkText = (latitude, longitude) => {
    const username = localStorage.getItem("in_username") || localStorage.getItem("username") || "Unknown";
    const lat = typeof latitude !== 'undefined' && latitude !== null ? latitude
      : (typeof this.state.watermarkLatitude !== 'undefined' && this.state.watermarkLatitude !== null ? this.state.watermarkLatitude
      : (localStorage.getItem("latitude") ||
        localStorage.getItem("lat") ||
        localStorage.getItem("in_latitude") ||
        localStorage.getItem("gps_latitude") ||
        localStorage.getItem("current_latitude") ||
        "0.0000"));
    const lon = typeof longitude !== 'undefined' && longitude !== null ? longitude
      : (typeof this.state.watermarkLongitude !== 'undefined' && this.state.watermarkLongitude !== null ? this.state.watermarkLongitude
      : (localStorage.getItem("longitude") ||
        localStorage.getItem("long") ||
        localStorage.getItem("in_longitude") ||
        localStorage.getItem("gps_longitude") ||
        localStorage.getItem("current_longitude") ||
        "0.0000"));
    const now = new Date();
    const date = now.toISOString().split('T')[0];
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${hours}:${minutes}:${seconds}`;
    return `${lat}, ${lon}, ${date}, ${timestamp}, ${username} - Navadhan Original Seen and Verified.`;
  };

  getDefaultWatermarkConfig = (imageWidth, imageHeight) => {
    const x = Math.max(20, imageWidth - 320);
    const y = Math.max(40, imageHeight - 80);
    return {
      text: this.getWatermarkText(),
      fontSize: 18,
      color: "#000000",
      opacity: 1.0,
      x,
      y,
      angle: 0,
      bold: false,
    };
  };

  getTextDimensions = (text, fontSize, bold = false, maxWidth = 1000) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const fontWeight = bold ? 'bold' : 'normal';
    ctx.font = `${fontWeight} ${fontSize}px Arial`;
    const lineHeight = fontSize + 4;
    const lines = this.wrapText(ctx, text, maxWidth, lineHeight);
    let width = 0;
    lines.forEach((line) => {
      width = Math.max(width, ctx.measureText(line).width);
    });
    return {
      width,
      height: lines.length * lineHeight,
    };
  };

  constrainPosition = (x, y, imageWidth, imageHeight, textWidth, textHeight) => {
    const padding = 10;
    const constrainedX = Math.max(padding, Math.min(x, imageWidth - textWidth - padding));
    const constrainedY = Math.max(padding, Math.min(y, imageHeight - textHeight - padding));
    return { x: constrainedX, y: constrainedY };
  };

  wrapText = (ctx, text, maxWidth, lineHeight) => {
    const paragraphs = text.split('\n');
    const lines = [];

    paragraphs.forEach((paragraph, paragraphIndex) => {
      const words = paragraph.split(' ');
      let currentLine = '';

      words.forEach((word) => {
        const testLine = currentLine ? currentLine + ' ' + word : word;
        const metrics = ctx.measureText(testLine);
        if (metrics.width > maxWidth && currentLine) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      });

      if (currentLine) {
        lines.push(currentLine);
      }

      if (paragraphIndex < paragraphs.length - 1) {
        lines.push('');
      }
    });

    return lines;
  };

  applyWatermark = (canvas, ctx, config) => {
    const { text, x, y, fontSize, color, opacity, angle = 0, bold = false } = config;
    ctx.save();
    ctx.globalAlpha = opacity;
    const fontWeight = bold ? 'bold' : 'normal';
    ctx.font = `${fontWeight} ${fontSize}px Arial`;
    ctx.fillStyle = color;
    ctx.textAlign = "left";
    ctx.textBaseline = "top";

    const lineHeight = fontSize + 4;
    const maxWidth = canvas.width - x - 20;
    const lines = this.wrapText(ctx, text, maxWidth, lineHeight);

    let currentY = y;
    lines.forEach((line, index) => {
      if (currentY + lineHeight < canvas.height) {
        if (angle !== 0) {
          ctx.translate(x, currentY);
          ctx.rotate((angle * Math.PI) / 180);
          ctx.fillText(line, 0, 0);
          ctx.resetTransform();
        } else {
          ctx.fillText(line, x, currentY);
        }
        currentY += lineHeight;
      }
    });
    ctx.restore();
  };

  openWatermarkEditor = async (document, watermarkDocument = null) => {
    const sourceName = this.getDocumentSourceName(document);
    if (!sourceName) {
      this.setState({ watermarkError: "Unable to open document for watermarking." });
      return;
    }

    this.setState({ watermarkError: null, watermarkSaving: false, loading: true });

    try {
      const previewUrl = await this.fetchDocumentBlobUrl(document);
      if (this.state.watermarkObjectUrl && this.state.watermarkObjectUrl !== previewUrl) {
        URL.revokeObjectURL(this.state.watermarkObjectUrl);
      }

      this.setState(
        {
          selectedDocumentForWatermark: document,
          selectedWatermarkDocument: watermarkDocument,
          watermarkImageUrl: previewUrl,
          watermarkObjectUrl: previewUrl,
          watermarkError: null,
          watermarkSaving: false,
          loading: false,
          watermarkTextAutoGenerated: true,
          useDocumentGPS: false,
          watermarkTextEmpty: false,
        },
        () => {
          this.getCurrentLocation();
          this.initializeWatermarkPreview();
        }
      );
    } catch (error) {
      this.setState({
        watermarkError: error.message || "Failed to load document for watermarking",
        loading: false,
      });
    }
  };

  initializeWatermarkPreview = () => {
    const { watermarkImageUrl } = this.state;
    if (!watermarkImageUrl) return;

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const config = this.getDefaultWatermarkConfig(img.width, img.height);
      this.setState(
        {
          watermarkOriginalImage: img,
          watermarkCanvasWidth: img.width,
          watermarkCanvasHeight: img.height,
          watermarkEditorConfig: config,
          watermarkEditableText: config.text,
          watermarkBold: config.bold || false,
          watermarkError: null,
          watermarkTextEmpty: false,
        },
        this.drawWatermarkPreview
      );
    };
    img.onerror = () => {
      this.setState({ watermarkError: "Failed to load document preview." });
    };
    img.src = watermarkImageUrl;
  };

  drawWatermarkPreview = () => {
    const canvas = this.watermarkCanvasRef.current;
    const { watermarkOriginalImage, watermarkEditorConfig, watermarkCanvasWidth, watermarkCanvasHeight } = this.state;
    if (!canvas || !watermarkOriginalImage || !watermarkEditorConfig) return;

    canvas.width = watermarkCanvasWidth;
    canvas.height = watermarkCanvasHeight;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(watermarkOriginalImage, 0, 0, watermarkCanvasWidth, watermarkCanvasHeight);
    this.applyWatermark(canvas, ctx, watermarkEditorConfig);
  };

  handleWatermarkFontSizeChange = (e) => {
    const fontSize = parseInt(e.target.value, 10);
    const config = { ...this.state.watermarkEditorConfig, fontSize };
    this.setState({ watermarkEditorConfig: config }, this.drawWatermarkPreview);
  };

  handleWatermarkColorChange = (e) => {
    const config = { ...this.state.watermarkEditorConfig, color: e.target.value };
    this.setState({ watermarkEditorConfig: config }, this.drawWatermarkPreview);
  };

  handleWatermarkOpacityChange = (e) => {
    const config = { ...this.state.watermarkEditorConfig, opacity: parseFloat(e.target.value) };
    this.setState({ watermarkEditorConfig: config }, this.drawWatermarkPreview);
  };

  handleWatermarkMouseDown = (e) => {
    const canvas = this.watermarkCanvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    const { watermarkEditorConfig } = this.state;
    if (!watermarkEditorConfig) return;

    const maxWidth = canvas.width - watermarkEditorConfig.x - 20;
    const textDim = this.getTextDimensions(watermarkEditorConfig.text, watermarkEditorConfig.fontSize, watermarkEditorConfig.bold, maxWidth);
    if (
      x >= watermarkEditorConfig.x - 10 &&
      x <= watermarkEditorConfig.x + textDim.width + 10 &&
      y >= watermarkEditorConfig.y - 10 &&
      y <= watermarkEditorConfig.y + textDim.height + 10
    ) {
      this.setState({
        isDraggingWatermark: true,
        dragStart: { x, y },
        dragOffset: { x: x - watermarkEditorConfig.x, y: y - watermarkEditorConfig.y },
      });
    }
  };

  handleWatermarkMouseMove = (e) => {
    if (!this.state.isDraggingWatermark) return;
    const canvas = this.watermarkCanvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);

    const config = { ...this.state.watermarkEditorConfig };
    const textDim = this.getTextDimensions(config.text, config.fontSize, config.bold, this.state.watermarkCanvasWidth - config.x - 20);
    const constrained = this.constrainPosition(
      x - this.state.dragOffset.x,
      y - this.state.dragOffset.y,
      this.state.watermarkCanvasWidth,
      this.state.watermarkCanvasHeight,
      textDim.width,
      textDim.height
    );

    config.x = constrained.x;
    config.y = constrained.y;
    this.setState({ watermarkEditorConfig: config }, this.drawWatermarkPreview);
  };

  handleWatermarkMouseUp = () => {
    if (this.state.isDraggingWatermark) {
      this.setState({ isDraggingWatermark: false });
    }
  };

  handleWatermarkReset = () => {
    const { watermarkCanvasWidth, watermarkCanvasHeight } = this.state;
    const config = this.getDefaultWatermarkConfig(watermarkCanvasWidth, watermarkCanvasHeight);
    this.setState(
      {
        watermarkEditorConfig: config,
        watermarkEditableText: config.text,
        watermarkBold: config.bold || false,
        watermarkTextAutoGenerated: true,
        watermarkTextEmpty: false,
      },
      () => {
        this.getCurrentLocation();
        this.drawWatermarkPreview();
      }
    );
  };

  handleWatermarkTextChange = (e) => {
    const newText = e.target.value;
    const config = { ...this.state.watermarkEditorConfig, text: newText };
    const textLength = newText.trim().length;
    let validationError = "";
    let isTextEmpty = false;
    
    if (textLength === 0) {
      validationError = "✗ Watermark text is required. Please enter text to continue.";
      isTextEmpty = true;
    } else if (textLength < 20) {
      validationError = `✗ Minimum 20 characters required. Current: ${textLength}/20-500`;
      isTextEmpty = true;
    } else if (textLength > 500) {
      validationError = `✗ Maximum 500 characters allowed. Current: ${textLength}/20-500`;
      isTextEmpty = true;
    }
    
    this.setState({ 
      watermarkEditorConfig: config, 
      watermarkEditableText: newText, 
      watermarkTextAutoGenerated: false, 
      watermarkTextEmpty: isTextEmpty,
      watermarkTextValidationError: validationError
    }, this.drawWatermarkPreview);
  };

  handleWatermarkBoldChange = (e) => {
    const bold = e.target.checked;
    const config = { ...this.state.watermarkEditorConfig, bold };
    this.setState({ watermarkEditorConfig: config, watermarkBold: bold }, this.drawWatermarkPreview);
  };

  handleUseDocumentGPSChange = (e) => {
    const useDocumentGPS = e.target.checked;
    this.setState((prevState) => {
      const config = prevState.watermarkEditorConfig ? { ...prevState.watermarkEditorConfig } : null;
      const latitude = useDocumentGPS && prevState.selectedDocumentForWatermark && prevState.selectedDocumentForWatermark.latitude !== undefined
        ? prevState.selectedDocumentForWatermark.latitude
        : prevState.watermarkLatitude;
      const longitude = useDocumentGPS && prevState.selectedDocumentForWatermark && prevState.selectedDocumentForWatermark.longitude !== undefined
        ? prevState.selectedDocumentForWatermark.longitude
        : prevState.watermarkLongitude;

      if (config && prevState.watermarkTextAutoGenerated) {
        config.text = this.getWatermarkText(latitude, longitude);
      }

      return {
        useDocumentGPS,
        watermarkEditorConfig: config,
        watermarkEditableText: config ? config.text : prevState.watermarkEditableText,
      };
    }, this.drawWatermarkPreview);
  };

  downloadWatermarkedPreview = () => {
    const canvas = this.watermarkCanvasRef.current;
    if (!canvas) return;
    canvas.toBlob((blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `watermarked-preview-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 'image/png');
  };

  handleWatermarkSave = async () => {
    const { selectedDocumentForWatermark, api_token, selectedFamilyMember, household_id, watermarkLatitude, watermarkLongitude } = this.state;
    if (!selectedDocumentForWatermark || !selectedFamilyMember || !household_id) return;

    const watermarkDocument = this.state.selectedWatermarkDocument;
    const rawFilename = this.getDocumentSourceName(watermarkDocument || selectedDocumentForWatermark);
    
    // Extract components for filename generation
    const householdNumber = this.state.householdNumber;
    const memberIndex = this.state.familyMembers.findIndex(m => m.family_member_id === selectedFamilyMember.family_member_id);
    const memberLetter = String.fromCharCode(65 + memberIndex); // A for first, B for second, etc.
    const documentType = this.extractDocumentType(rawFilename, memberLetter);
    
    // Generate filename in the required format: "random3digit_HouseholdNumber-MemberLetter_DocumentTypeWatermark.ext"
    // Example: "429_MP001LE003876-A_AadhaarBackWatermark.jpeg"
    const filename = this.generateSaveFilename(householdNumber, memberLetter, documentType, rawFilename);
    
    // Determine latitude and longitude based on useDocumentGPS checkbox
    const useDocumentGPS = this.state.useDocumentGPS;
    const documentGPS = useDocumentGPS && this.state.selectedDocumentForWatermark ? {
      latitude: this.state.selectedDocumentForWatermark.latitude,
      longitude: this.state.selectedDocumentForWatermark.longitude
    } : null;

    const latitude = documentGPS ? documentGPS.latitude : (watermarkLatitude ||
      localStorage.getItem("latitude") ||
      localStorage.getItem("lat") ||
      localStorage.getItem("in_latitude") ||
      localStorage.getItem("gps_latitude") ||
      localStorage.getItem("current_latitude") ||
      "0.0000");
    const longitude = documentGPS ? documentGPS.longitude : (watermarkLongitude ||
      localStorage.getItem("longitude") ||
      localStorage.getItem("long") ||
      localStorage.getItem("in_longitude") ||
      localStorage.getItem("gps_longitude") ||
      localStorage.getItem("current_longitude") ||
      "0.0000");
    const gps_address =
      localStorage.getItem("gps_address") ||
      localStorage.getItem("location_address") ||
      localStorage.getItem("location") ||
      localStorage.getItem("address") ||
      localStorage.getItem("current_location") ||
      (await this.getAddressFromLatLng(latitude, longitude)) ||
      `${latitude},${longitude}`;

    this.setState({ watermarkSaving: true, watermarkError: null });

    try {
      // Step 1: Upload the watermarked image to GCS
      const canvas = this.watermarkCanvasRef.current;
      if (!canvas) {
        throw new Error("Canvas reference not found");
      }

      const watermarkBlob = await new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error("Failed to generate watermarked image blob"));
          }
        }, "image/jpeg");
      });

      // Get the original source path to extract the directory structure
      const watermarkSourcePath = watermarkDocument
        ? this.getDocumentSourceName(watermarkDocument)
        : this.getDocumentSourceName(this.state.selectedDocumentForWatermark);
      const normalizedSourcePath = this.normalizeSourceBlobPath(watermarkSourcePath);
      
      // Extract just the directory path WITHOUT the random number
      const pathParts = normalizedSourcePath.split('/');
      const kycIndex = pathParts.findIndex(part => part === 'KYC');
      let directoryPath = '';
      
      if (kycIndex >= 0) {
        // Take KYC, year, month parts only (e.g., KYC/2026/4)
        directoryPath = pathParts.slice(kycIndex, Math.min(kycIndex + 3, pathParts.length)).join('/');
      } else {
        // If no KYC folder, take all parts except the last one (filename)
        directoryPath = normalizedSourcePath.split('/').slice(0, -1).join('/');
      }
      
      // Construct remote_path without trailing slash and without random number
      const remotePath = `navadhanftp/${process.env.REACT_APP_ENVIRONMENT}/${directoryPath}`;
      
      console.log('=== Upload Payload ===');
      console.log('remote_path:', remotePath);
      console.log('filename:', filename);
      console.log('Expected full path:', `${remotePath}/${filename}`);

      // Upload to GCS
      const formData = new FormData();
      formData.append("file", watermarkBlob, filename);
      formData.append("remote_path", remotePath);

      const uploadResponse = await customFetch(`${process.env.REACT_APP_FILE_DOWNLOAD}/gcs/upload`, {
        method: "POST",
        headers: {
          "api-token": api_token,
        },
        body: formData,
      });

      if (!uploadResponse.ok) {
        const apiError = uploadResponse.headers.get("api_error_message");
        throw new Error(apiError || `GCS upload failed with status ${uploadResponse.status}`);
      }

      let uploadData;
      try {
        uploadData = await uploadResponse.json();
      } catch (e) {
        // If response is not JSON, treat as plain text (the file path)
        uploadData = await uploadResponse.text();
      }

      let savedFilePath;
      if (typeof uploadData === 'string') {
        // Response is the file path directly
        savedFilePath = uploadData;
      } else if (uploadData.status !== 1) {
        throw new Error(uploadData.msg || "Failed to upload watermarked file to GCS");
      } else {
        // Response is JSON object
        savedFilePath = uploadData.data || uploadData.file_path || `${remotePath}/${filename}`;
      }

      console.log('File saved at:', savedFilePath);

      // Step 2: Determine the watermark document type ID
      let watermarkDocumentTypeId;

      // If watermark document already exists, use its document type ID directly
      if (watermarkDocument && watermarkDocument.upload_document_type_id) {
        watermarkDocumentTypeId = watermarkDocument.upload_document_type_id;
        console.log('Using existing watermark document type ID:', watermarkDocumentTypeId);
      } else {
        // Otherwise, fetch the watermark document type ID from API
        // Pass the original document type name - the API will return the watermark variant ID
        const originalDocumentTypeName = selectedDocumentForWatermark.upload_document_type_name || '';
        
        console.log('Fetching watermark document type ID for:', originalDocumentTypeName);
        
        const apiUrl = `${process.env.REACT_APP_URL}/get/document/type/id?upload_document_type_name=${encodeURIComponent(originalDocumentTypeName)}`;
        const documentTypeResponse = await customFetch(apiUrl, {
          method: "GET",
          headers: {
            "api-token": api_token,
          },
        });

        if (!documentTypeResponse.ok) {
          const apiError = documentTypeResponse.headers.get("api_error_message");
          throw new Error(apiError || `Failed to fetch document type ID for ${originalDocumentTypeName}`);
        }

        const documentTypeData = await documentTypeResponse.json();
        if (documentTypeData.status !== 1) {
          throw new Error(documentTypeData.msg || `Document type "${originalDocumentTypeName}" not found`);
        }

        watermarkDocumentTypeId = documentTypeData.upload_document_type_id;
        if (!watermarkDocumentTypeId) {
          throw new Error(`No document type ID returned for ${originalDocumentTypeName}`);
        }

        console.log('Document type ID for watermark:', watermarkDocumentTypeId);
      }

      // Step 3: Save document metadata with the watermark document type ID
      const saveResponse = await customFetch(`${process.env.REACT_APP_URL}/save/household/documents`, {
        method: "POST",
        headers: {
          "api-token": api_token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          household_id,
          family_member_id: selectedFamilyMember.family_member_id,
          upload_document_type_id: watermarkDocumentTypeId,
          filename: savedFilePath.replace(/^dev\//, ''),
          uploaded_by: parseInt(localStorage.getItem("in_userid"), 10) || 0,
          longitude,
          latitude,
          gps_address,
        }),
      });

      const saveData = await saveResponse.json();
      if (saveData.status !== 1) {
        throw new Error(saveData.msg || "Failed to save watermark metadata");
      }

      this.setState({ selectedDocumentForWatermark: null, selectedWatermarkDocument: null, watermarkSaving: false }, () => {
        if (selectedFamilyMember) {
          this.fetchDocumentsForMember(selectedFamilyMember);
        }
      });
    } catch (error) {
      this.setState({ watermarkError: error.message || "Save failed", watermarkSaving: false });
    }
  };

  randomizePathDigits = (path) => {
    if (!path) return "";
    
    // Pattern to match three digits followed by underscore in a path like "KYC/2026/4/599_"
    const digitsPattern = /\/(\d{3})_/;
    const match = path.match(digitsPattern);
    
    if (match) {
      const currentDigits = match[1];
      let newDigits;
      
      // Generate random three-digit number different from current
      do {
        newDigits = Math.floor(Math.random() * 900 + 100).toString();
      } while (newDigits === currentDigits);
      
      // Replace the three digits with the new random ones
      return path.replace(digitsPattern, `/${newDigits}_`);
    }
    
    return path;
  };

  handleWatermarkCancel = () => {
    if (this.state.watermarkObjectUrl) {
      URL.revokeObjectURL(this.state.watermarkObjectUrl);
    }
    this.setState({
      selectedDocumentForWatermark: null,
      selectedWatermarkDocument: null,
      watermarkImageUrl: null,
      watermarkObjectUrl: null,
      watermarkEditorConfig: null,
      watermarkError: null,
      watermarkTextEmpty: false,
    });
  };

  render() {
    const {
      householdNumber,
      loading,
      error,
      showDocuments,
      showFamilyMembers,
      familyMembers,
      selectedFamilyMember,
      kycDocuments,
      effective_designation_id,
      api_token,
      selectedDocumentForWatermark,
      watermarkEditorConfig,
      watermarkError,
      watermarkSaving,
      userId,
    } = this.state;

    // Show inline watermark editor if a document is selected
    if (selectedDocumentForWatermark) {
      const { watermarkCanvasWidth, watermarkCanvasHeight } = this.state;
      return (
        <>
          <section className="main-sec">
            <div className="container fix-width">
              <div className="kyc-documents-container">
                <div className="kyc-header">
                  <button
                    className="kyc-back-button"
                    onClick={this.handleWatermarkCancel}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M15 18L9 12L15 6"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                    <span>Back to Documents</span>
                  </button>

                  <h1 className="kyc-main-title">Watermark Controls</h1>

                  <button
                    className="kyc-logout-button"
                    onClick={() => logout()}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2"/>
                      <path d="M16 15L21 10L16 5" stroke="currentColor" strokeWidth="2"/>
                      <path d="M21 10H9" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                    <span>Logout</span>
                  </button>
                </div>
              </div>
              <div className="watermark-editor-shell">
                <div className="watermark-editor-grid">
                  <div className="watermark-preview-card">
                    <h2>Image Preview</h2>
                    {watermarkError && <div className="watermark-error-message">{watermarkError}</div>}
                    <div className="watermark-canvas-wrapper">
                      <canvas
                        ref={this.watermarkCanvasRef}
                        className="watermark-canvas"
                        onMouseDown={this.handleWatermarkMouseDown}
                        onMouseMove={this.handleWatermarkMouseMove}
                        onMouseUp={this.handleWatermarkMouseUp}
                        onMouseLeave={this.handleWatermarkMouseUp}
                        style={{ width: "100%", maxWidth: "100%", cursor: this.state.isDraggingWatermark ? "grabbing" : "grab" }}
                      />
                    </div>
                  </div>

                  <div className="watermark-controls-card">
                    <h2>Watermark Controls</h2>
                    <div className="watermark-controls-row">
                      <div className="watermark-control-group full-width">
                        <label>Fixed Watermark Text</label>
                        <textarea
                          value={watermarkEditorConfig ? watermarkEditorConfig.text : ""}
                          onChange={this.handleWatermarkTextChange}
                          className="watermark-textarea"
                          placeholder="Edit watermark text here"
                          minLength={20}
                          maxLength={500}
                        />
                        {this.state.watermarkTextValidationError && (
                          <div style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "5px",
                            fontWeight: "bold"
                          }}>
                            {this.state.watermarkTextValidationError}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="watermark-controls-row">
                      <div className="watermark-control-group">
                        <label>Font Size ({watermarkEditorConfig ? watermarkEditorConfig.fontSize : 0}px)</label>
                        <input
                          type="range"
                          min="12"
                          max="60"
                          value={watermarkEditorConfig ? watermarkEditorConfig.fontSize : 18}
                          onChange={this.handleWatermarkFontSizeChange}
                          className="watermark-slider"
                        />
                      </div>
                      <div className="watermark-control-group">
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.watermarkBold}
                            onChange={this.handleWatermarkBoldChange}
                            className="watermark-bold-checkbox"
                          />
                          <span className="watermark-bold-label">Bold Text</span>
                        </label>
                      </div>
                      <div className="watermark-control-group">
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.useDocumentGPS}
                            onChange={this.handleUseDocumentGPSChange}
                            className="watermark-use-doc-gps-checkbox"
                          />
                          <span className="watermark-use-doc-gps-label">Use Document GPS</span>
                        </label>
                      </div>
                    </div>

                    <div className="watermark-controls-row">
                      <div className="watermark-control-group">
                        <label>Opacity ({watermarkEditorConfig ? Math.round(watermarkEditorConfig.opacity * 100) : 100}%)</label>
                        <input
                          type="range"
                          min="0.1"
                          max="1"
                          step="0.05"
                          value={watermarkEditorConfig ? watermarkEditorConfig.opacity : 1.0}
                          onChange={this.handleWatermarkOpacityChange}
                          className="watermark-slider"
                        />
                      </div>
                      <div className="watermark-control-group">
                        <label>Text Color</label>
                        <div className="color-picker-wrapper">
                          <input
                            type="color"
                            value={watermarkEditorConfig ? watermarkEditorConfig.color : "#000000"}
                            onChange={this.handleWatermarkColorChange}
                            className="watermark-color-picker"
                          />
                          <span className="color-value">{watermarkEditorConfig ? watermarkEditorConfig.color : "#000000"}</span>
                        </div>
                      </div>
                    </div>

                    <div className="watermark-button-group">
                      <button className="watermark-reset-btn" onClick={this.handleWatermarkReset}>Reset</button>
                      <button className="watermark-save-btn" onClick={this.handleWatermarkSave} disabled={watermarkSaving || this.state.watermarkTextEmpty}>
                        {watermarkSaving ? "Saving..." : "Save"}
                      </button>
                      <button className="watermark-button-download-btn" onClick={this.downloadWatermarkedPreview} disabled={this.state.watermarkTextEmpty}>Download</button>
                      <button className="watermark-cancel-btn" onClick={this.handleWatermarkCancel}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <ChatSupportBtn history={this.props.history} />
        </>
      );
    }

    return (
      <>
        <section className="main-sec">
          <div className="container fix-width">
            <div className="kyc-documents-container">
              <div className="kyc-header">
                <button
                  className="kyc-back-button"
                  onClick={() => {
                    this.props.history.push({
                      pathname: "/kyc_activities",
                      state: {
                        api_token: api_token,
                        effective_designation_id: effective_designation_id,
                      },
                    });
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15 18L9 12L15 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span>Back</span>
                </button>

                <h1 className="kyc-main-title">KYC Documents</h1>

                <button
                  className="kyc-logout-button"
                  onClick={() => logout()}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2"/>
                    <path d="M16 15L21 10L16 5" stroke="currentColor" strokeWidth="2"/>
                    <path d="M21 10H9" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Logout</span>
                </button>
              </div>

              <div className="kyc-search-section">
                <div className="kyc-search-card">
                  <div className="kyc-search-input-wrapper">
                    <input
                      type="text"
                      className="kyc-search-input"
                      placeholder="Enter Household Number"
                      value={householdNumber}
                      onChange={(e) => {
                        this.setState({ householdNumber: e.target.value });
                        if (error) {
                          this.setState({ error: null });
                        }
                      }}
                      onKeyPress={this.handleKeyPress}
                      disabled={loading}
                    />
                    <button
                      className="kyc-search-button"
                      onClick={this.fetchKYCDocuments}
                      disabled={loading || !householdNumber.trim()}
                    >
                      {loading ? (
                        <div className="kyc-button-spinner"></div>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                          <path d="M16 16L21 21" stroke="currentColor" strokeWidth="2" />
                        </svg>
                      )}
                    </button>
                  </div>
                  {error && (
                    <div className="kyc-error-message">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                        <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
                        <circle cx="12" cy="16" r="1" fill="currentColor" />
                      </svg>
                      <span>{error}</span>
                    </div>
                  )}
                </div>
              </div>

              {showFamilyMembers && familyMembers.length > 0 && (
                <div className="kyc-family-members-section">
                  <div className="kyc-section-header">
                    <h2>Select Family Member</h2>
                  </div>
                  <div className="kyc-family-members-compact">
                    {familyMembers.map((member) => (
                      <div
                        key={member.family_member_id}
                        className={`kyc-family-member-compact ${
                          selectedFamilyMember && selectedFamilyMember.family_member_id === member.family_member_id
                            ? "active"
                            : ""
                        }`}
                        onClick={() => this.fetchDocumentsForMember(member)}
                      >
                        <div className="family-member-profile-icon">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20V21H4V20Z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                        <div className="family-member-compact-info">
                          <span className="family-member-compact-name">
                            {member.family_member_name}
                          </span>
                          <span className="family-member-compact-gender">
                            {member.gender === "M" ? "Male" : "Female"}
                          </span>
                          <span className="family-member-compact-id">
                            {member.family_member_id}
                          </span>
                        </div>
                        <div className="family-member-compact-action">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M9 6L15 12L9 18"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}


              {showDocuments && kycDocuments.length > 0 && (
                <div className="kyc-documents-section">
                  {selectedFamilyMember && (
                    <div className="kyc-documents-section-header">
                      <h3>Documents for {selectedFamilyMember.family_member_name}</h3>
                    </div>
                  )}
                  <div className="kyc-documents-table-container">
                    <table className="kyc-documents-table">
                      <thead>
                        <tr>
                          <th>Document Type</th>
                          <th>Version</th>
                          <th>Document ID</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {kycDocuments.map((docGroup) => (
                          <React.Fragment key={docGroup.documentType}>
                            {docGroup.original && (
                              <tr className="kyc-document-row original">
                                <td className="kyc-document-type-cell" rowSpan={docGroup.watermark ? 2 : 1}>
                                  <div className="kyc-document-type-name">{docGroup.documentType}</div>
                                </td>
                                <td className="kyc-document-version-cell">
                                  <div className="kyc-document-version-label">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                      <path
                                        d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    Original
                                  </div>
                                </td>
                                <td className="kyc-document-id-cell">
                                  <span className="kyc-document-id">{docGroup.original.document_id || docGroup.original.id}</span>
                                </td>
                                <td className="kyc-document-actions-cell">
                                  <div className="kyc-document-actions">
                                    <button
                                      className="kyc-action-btn kyc-view-btn"
                                      onClick={() => this.openPreviewModal(docGroup.original)}
                                      title="View Document"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                          d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                    <button
                                      className="kyc-action-btn kyc-edit-btn"
                                      onClick={() => this.openWatermarkEditor(docGroup.original, docGroup.watermark)}
                                      title="Edit Watermark"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                          d="M11 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V13"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M17.5 1.5L21.7 5.7C21.8947 5.89473 21.8947 6.20527 21.7 6.4L11.7 16.4C11.5 16.6 11.2 16.7 10.9 16.7H7V13.1C7 12.8 7.1 12.5 7.3 12.3L17.3 2.3C17.4947 2.10527 17.8053 2.10527 18 2.3L17.5 1.5Z"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )}
                            {docGroup.watermark && (
                              <tr className="kyc-document-row watermark">
                                <td className="kyc-document-version-cell">
                                  <div className="kyc-document-version-label">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                      <path
                                        d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                    Watermark
                                  </div>
                                </td>
                                <td className="kyc-document-id-cell">
                                  <span className="kyc-document-id">{docGroup.watermark.document_id || docGroup.watermark.id}</span>
                                </td>
                                <td className="kyc-document-actions-cell">
                                  <div className="kyc-document-actions">
                                    <button
                                      className="kyc-action-btn kyc-view-btn"
                                      onClick={() => this.openPreviewModal(docGroup.watermark)}
                                      title="View Watermarked Document"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                          d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
        {this.state.showDocumentModal && (
          <div className="document-preview-modal-overlay">
            <div className="document-preview-modal">
              <div className="document-preview-modal-header">
                <h3>Document Preview</h3>
                <button className="document-preview-close" onClick={this.closeDocumentModal}>
                  ×
                </button>
              </div>
              <div className="document-preview-modal-body">
                {this.state.documentPreviewUrl ? (
                  <img
                    src={this.state.documentPreviewUrl}
                    alt={this.state.documentPreviewName}
                    className="document-preview-image"
                  />
                ) : (
                  <div className="document-preview-loading">Loading preview…</div>
                )}
              </div>
            </div>
          </div>
        )}
        <ChatSupportBtn history={this.props.history} />
      </>
    );
  }
}

export default withRouter(KYCDocuments);
